import React from 'react';
import { Card, Badge } from 'react-bootstrap';
//import './HealthImplicationsStyles.css';

const HealthImplications = ({ implications }) => {
    const hasShortTerm = implications?.shortTerm?.length > 0;
    const hasLongTerm = implications?.longTerm?.length > 0;

    return (
        <Card className="clean-card shadow mb-4">
            <div className="card-header">
                <h3 className="mb-0">
                    <span className="health-icon">🧬</span> Health Implications
                </h3>
            </div>

            <Card.Body>
                <div className="implication-section mb-4">
                    <h5 className="implication-title">
                        <Badge className="badge warning implication-badge">Short-Term</Badge>
                    </h5>
                    <ul className="implication-list">
                        {hasShortTerm ? (
                            implications.shortTerm.map((item, idx) => (
                                <li key={idx} className="implication-item">⚡ {item}</li>
                            ))
                        ) : (
                            <li className="implication-item text-muted">None listed</li>
                        )}
                    </ul>
                </div>

                <div className="implication-section">
                    <h5 className="implication-title">
                        <Badge className="badge danger implication-badge">Long-Term</Badge>
                    </h5>
                    <ul className="implication-list">
                        {hasLongTerm ? (
                            implications.longTerm.map((item, idx) => (
                                <li key={idx} className="implication-item">🧠 {item}</li>
                            ))
                        ) : (
                            <li className="implication-item text-muted">None listed</li>
                        )}
                    </ul>
                </div>
            </Card.Body>
        </Card>
    );
};

export default HealthImplications;
